import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/permissions")({
  loader: () => ({ crumb: "Permissions" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
